import { Component, OnInit } from '@angular/core';
import { IntegrationsService } from '../services/integrations.service';

@Component({
  selector: 'app-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.css']
})
export class IntegrationsComponent implements OnInit {


  integrations: any = [];
  constructor(
    private integrationsService: IntegrationsService,
  ) { }

  ngOnInit(): void {
    this.getIntegrations();
  }

  async getIntegrations() {
    this.integrations = await new Promise(resolve =>
      this.integrationsService.getInegrations().subscribe(
        (res: any) => resolve(res.data)
      ));
  }

}
